<template>
    <loginContent/>
</template>

<script>
import loginContent from "@/views/login/components/loginContent";

export default {
  name: 'login',
  components:{
    loginContent,
  },
}
</script>

<style scoped>

</style>
